import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["minute"]
  static values = {
    apiMinute: { type: Number, default: 0 },
    period:   { type: String, default: "" }
  }

  connect() {
    if (!this.hasMinuteTarget) return
    if (this.periodValue === "Penalties" || this.periodValue === "Finished") return
    this.loadedAt = Date.now()
    this.tick()
    this.interval = setInterval(() => { this.tick() }, 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    if (this.apiMinuteValue <= 0) return
    const totalSeconds = (this.apiMinuteValue * 60) + Math.floor((Date.now() - this.loadedAt) / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    this.minuteTarget.textContent = `${minutes}:${String(seconds).padStart(2, "0")}`
  }
}
